<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">

            <header>
                <h2 i18n>Software-Partner</h2>
            </header>

            <p i18n>Sie benötigen effiziente Lösungen? Wir greifen auf etablierte und verlässliche Partner zurück, denn schließlich wollen wir das Rad nicht neu erfinden, sondern ihnen
                optimale Lösungen für ihre Anforderungen bieten.</p>

        </div>
    </section>
</div>
<div class="wrapper">
    <section class="container">
        <div class="row features justify-content-center">
            <section class="col-4 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>Lexware Office für AlbCode Kunden</h2>
                </header>
                <div class="image-wrapper first">
                    <a [routerLink]="['/partner/software/lexoffice']" class="image featured" aria-label="Zur Lexware-Office-Seite von AlbCode" i18n-aria-label><img src="/logos/lexoffice.png"
                            alt="Lexware Office Logo" i18n-alt /></a>
                </div>
                <p i18n>Mit der Online-Unternehmenslösung Lexware Office (früher: lexware) erledigt sich Ihre Buchhaltung fast automatisch.
                    Von der digitalen Belegerfassung über die Rechnungsstellung bis hin zur Buchhaltung in Sekunden.</p>

                <img class="tech-logo-middle2" src="/logos/lexoffice-integrationspartner-badge-bronze.png" alt="Lexware Office" i18n-alt>

                <ul class="actions text-center mt-3">
                    <li><a class="glow-on-hover p-3" [routerLink]="['/partner/software/lexoffice']" i18n>Mehr zu Lexware Office ...</a></li>
                </ul>
            </section>
            <section class="col-4 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>Create Powerful Online Forms</h2>
                </header>
                <div class="image-wrapper">
                    <a href="https://www.jotform.com/de/" target="_blank" rel="noopener noreferrer" class="image featured" id="jotform-link"
                        aria-label="Jotform Webseite in neuem Tab öffnen" i18n-aria-label><img src="/logos/jotform.png" alt="Jotform Logo" i18n-alt /></a>
                </div>
                <p i18n>Erstellen Sie kostenlose Formulare, Umfragen, Berichte und Apps. Analysieren Sie Formularantworten und automatisieren Sie Ihren Workflow mit leistungsstarken
                    Integrationen und Zahlungsfunktionen.</p>

                <img class="tech-logo-middle2" src="/logos/jotform_partner.png" alt="Jotform" i18n-alt>

                <ul class="actions text-center mt-3">
                    <li><a class="glow-on-hover p-3" href="https://www.jotform.com/de/" target="_blank" rel="noopener noreferrer" i18n>Mehr zu Jotform ...</a></li>
                </ul>
            </section>
            <section class="col-4 col-12-narrower feature">
                <header class="major">
                    <h2 i18n>Hornetsecurity</h2>
                </header>
                <div class="image-wrapper">
                    <a href="https://www.hornetsecurity.com/de/" target="_blank" rel="noopener noreferrer" class="image featured" id="hornetsecurity-link"
                        aria-label="Hornetsecurity Webseite in neuem Tab öffnen" i18n-aria-label><img src="/logos/hornetsecurtiy_logo.webp" alt="Logo Hornetsecurity" i18n-alt /></a>
                </div>
                <p i18n>Die Hornetsecurity-Sicherheitslösung unterstützt uns mit robusten Schutzmaßnahmen gegen moderne Bedrohungen wie Spam, Phishing und
                    Malware. Die
                    umfassenden und benutzerfreundlichen Sicherheitsfunktionen tragen maßgeblich dazu bei, die IT-Sicherheit unserer Kunden zu gewährleisten und
                    ihre
                    Daten zuverlässig zu schützen. Durch diese Partnerschaft sind wir in der Lage, Ihnen eine sichere, DSGVO-konforme Lösung anzubieten, die Ihre
                    Kommunikationsinfrastruktur schützt und Ihnen den Alltag vereinfacht.</p>

                <img class="tech-logo-middle2" src="/logos/hornet.png" alt="Hornetsecurity" i18n-alt>

                <ul class="actions text-center mt-3">
                    <li><a class="glow-on-hover p-3" href="https://www.hornetsecurity.com/de/" target="_blank" rel="noopener noreferrer" i18n>Mehr zu Hornetsecurity ...</a></li>
                </ul>
            </section>
        </div>
    </section>
</div>